import apiBase from "../../../api/axios";

const API_URL_TODOS = "/v1/ranking/resultados-evaluacion/todos/";
const API_URL_ESTADISTICAS = "/v1/ranking/resultados-evaluacion/estadisticas-completas/";

export const getResultadosEvaluacionService = async ({ 
  escuela = null, 
  plantel = null, 
  search = null,
  page = 1 
} = {}) => {
  const params = { page };
  if (escuela !== null) params.escuela = escuela;
  if (plantel !== null) params.plantel = plantel;
  if (search) params.search = search;
  
  const response = await apiBase.get(API_URL_TODOS, { params });
  return response.data;
};

export const getEstadisticasCompletasService = async ({ 
  escuela = null, 
  plantel = null 
} = {}) => {
  const params = {};
  if (escuela !== null) params.escuela = escuela;
  if (plantel !== null) params.plantel = plantel;
  
  const response = await apiBase.get(API_URL_ESTADISTICAS, { params });
  return response.data;
};
